export default __webpack_public_path__ + "static/media/logo-1.825ad2c1.svg";